

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'
import * as miningActions from '../../../Mining/mining.actions'
import * as quizzesActions from '../../../Quizzes/quizzes.actions'

import * as quizzesSelectors from '../../../Quizzes/quizzes.selectors'
import * as miningSelectors from '../../../Mining/mining.selectors'
import * as tutorialSelectors from '../../../../Tutorial/tutorial.selectors'

import MineTab from './MineTab'

const mapStateToProps = (state) => ({
  ownQuestions: miningSelectors.getOwnQuestions(state),
  disputedQuestions: miningSelectors.getDisputedQuestions(state),
  debatedQuestions: !tutorialSelectors.isTutorialMode(state)
    ? miningSelectors.getDebatedQuestions(state)
    : tutorialSelectors.getDebatesInfo(state),
  votedQuestion: quizzesSelectors.getVoteQuestion(state),
  totalLikes: miningSelectors.getTotalLikes(state),
  isTutorial: tutorialSelectors.isTutorialMode(state),
})
const mapDispatchToProps = (dispatch) => ({
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  getOwnQuestions: bindActionCreators(miningActions.getOwnQuestions, dispatch),
  setVoteQuestion: bindActionCreators(quizzesActions.setVoteQuestion, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MineTab))
